<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import Loading from "vue-loading-overlay";
import ModalModelBellacloudZoom from "../../components/Modais/ModalBellaCloudZoom.vue";
import BoxVideo from "components/Model/BoxVideo.vue";
import IconeBds from "assets/img/icone_BDS.png";
import ModalModelBellacloud from "../../components/Modais/ModalModelBellacloud.vue";
</script>

<template>
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
      <div class="block--gray">
        <div class="container">
          <div class="row pt-3">
            <div class="col-lg-4 pt-4">
              <h1 class="title">{{ translate.title }}</h1>
            </div>
            <div class="col-lg-5 pt-2 d-flex align-items-center">
              <span class="subtitle">{{ translate.subTitle }}</span>
            </div>
          </div>
          <hr class="mb-3" />
          <div class="row d-flex justify-content-between">
            <div class="col-lg-6 col-md-6 col-sm-10 col-10">
              <div class="routes">
                <span style="margin-right: 15px" class="cursor-pointer" @click="goBack()">
                  {{ $route.query.q ?? "BELLA CLOUD" }}
                </span>
                <font-awesome-icon :icon="['fas', 'angle-right']" />
                <span style="margin-left: 15px; cursor: default">
                  {{ !myfavorites ? list.name : translate.goFavoriteModels }}
                </span>
              </div>
            </div>
            <div class="col-6 d-flex justify-content-end" v-if="!isMobile()">
              <div class="routes">
                <span
                  style="margin-right: 15px"
                  class="cursor-pointer"
                  @click="goLink('BellaCloudTopPage', { locale })"
                >
                  {{ translate.topalbum }}
                </span>
                <span
                  style="margin-right: 15px"
                  class="cursor-pointer"
                  @click="getPhotosPaginateAlbumId()"
                >
                  {{ translate.photos }}
                </span>
                <span
                  style="margin-right: 15px"
                  class="cursor-pointer"
                  @click="getVideosAlbumId()"
                >
                  {{ translate.video }}
                </span>
                <span
                  v-if="isLoggedIn"
                  style="margin-right: 15px"
                  class="cursor-pointer"
                  @click="getFavoritesModels()"
                >
                  {{ translate.goFavoriteModels }}
                </span>
                <span style="margin-right: 15px" class="cursor-pointer" @click="goBack()">
                  {{ translate.goBackAlbuns }}
                </span>
              </div>
            </div>
            <div class="dropdown col-2 d-flex justify-content-end" v-else>
              <font-awesome-icon
                class="dropdown-toggle"
                :icon="['fas', 'bars']"
                data-toggle="dropdown"
                aria-expanded="false"
                @click="showDropMenu = !showDropMenu"
              />
              <div class="dropdown-menu" :class="{ show: showDropMenu }">
                <a class="dropdown-item" href="#">
                  <span
                    style="margin-right: 15px"
                    class="cursor-pointer"
                    @click="goLink('BellaCloudTopPage', { locale })"
                  >
                    {{ translate.topalbum }}
                  </span>
                </a>
                <a class="dropdown-item" href="#">
                  <span
                    style="margin-right: 15px"
                    class="cursor-pointer"
                    @click="getPhotosPaginateAlbumId()"
                  >
                    {{ translate.photos }}
                  </span>
                </a>
                <a class="dropdown-item" href="#">
                  <span
                    style="margin-right: 15px"
                    class="cursor-pointer"
                    @click="getVideosAlbumId()"
                  >
                    {{ translate.video }}
                  </span>
                </a>
                <a class="dropdown-item" href="#" v-if="isLoggedIn">
                  <span
                    style="margin-right: 15px"
                    class="cursor-pointer"
                    @click="getFavoritesModels()"
                  >
                    {{ translate.goFavoriteModels }}
                  </span>
                </a>
                <a class="dropdown-item" href="#">
                  <span
                    style="margin-right: 15px"
                    class="cursor-pointer"
                    @click="goBack()"
                  >
                    {{ translate.goBackAlbuns }}
                  </span>
                </a>
              </div>
            </div>
          </div>
          <hr class="mt-3" />
        </div>
        <!-- Meus Albums Logados-->
        <div class="pb-5">
          <div class="container">
            <loading
              v-model:active="loading"
              :is-full-page="false"
              color="#b20000"
              height="200"
            />
            <div class="row pt-3" v-if="list.name">
              <div class="col-12 header-album">
                <spam class="name-pasta" @click="goLink('BellaCloudPage', { locale })">
                  {{ "BellaCloud" }} -
                  {{ !myfavorites ? list.name : translate.goFavoriteModels }}
                </spam>
                <span class="by-user" v-if="!myfavorites">
                  {{ translate.by }}
                  {{ list.user.name }}
                </span>
                <span class="likes" @click="getLike" v-if="!myfavorites">
                  <font-awesome-icon
                    :icon="['fas', 'thumbs-up']"
                    :color="list.curtiu ? '#b20000' : '#999'"
                    style="font-size: 24px; margin-inline-start: 25px"
                  />
                  {{ list.likes }} LIKES
                </span>
              </div>
              <div class="col-12 p-5" v-if="!pagesImages.data.length">
                <loading
                  v-model:active="loadingPhotos"
                  :is-full-page="false"
                  color="#b20000"
                  background-color="#ffffff0d"
                  height="200"
                />
              </div>
              <loading
                v-else
                v-model:active="loadingPhotos"
                :is-full-page="false"
                color="#b20000"
                background-color="#ffffff0d"
                height="200"
              />
              <div
                v-if="!myfavorites"
                class="d-flex flex-row align-items-center justify-content-center flex-wrap py-3 mb-3"
              >
                <draggable ref="myPhotosPosition"
                  item-key="id"
                  tag="transition-group"
                  :handle="isMobile()?'.handle':''"
                  :animation="500"                  
                  :list="pagesImages.data"                   
                  :sort="list.owner ? true : false"
                  :move="checkMove">
                  <template #item="{element}">
                    <div class="col-lg-3 col-12 mt-5">
                      <div
                        v-if="element.photo"
                        class="photos d-flex flex-row align-items-center justify-content-center flex-wrap pt-3"
                      >
                        <div
                          class="thumb"
                          @mouseover="visibleTrash = true"
                          @mouseleave="visibleTrash = false"
                        >
                          <img
                            class="thumb-pastas col-6"
                            :src="element.photo"
                            :alt="list.name + '-' + element.essay_photos_id"
                            @click="showModalModelSlideShow(true, element)"
                          />
                          <div
                            v-if="list.owner && (visibleTrash || isMobile())"
                            class="trash"
                            @click="
                              removePhotoId(list.id, element.essay_photos_id, showModalMessages)
                            "
                          >
                            <font-awesome-icon :icon="['fas', 'trash']" />
                          </div>
                          <div
                            v-if="!list.owner && (visibleTrash || isMobile()) && isLoggedIn"
                            class="trash"
                            @click="adicionarMyBellaCloud(element.essay_photos_id)"
                          >
                            <font-awesome-icon :icon="['fas', 'cloud-arrow-down']" />
                          </div>
                          <div class="col-12 my-2 d-flex">
                            <div role="button" class="col-2 pb-3 handle" v-if="list.owner">
                              <font-awesome-icon :icon="['fas', 'up-down-left-right']" size="lg"/>
                            </div>
                            <div style="margin: 0 auto;">
                              <router-link
                                :to="{
                                  name: 'ModelPage',
                                  params: {
                                    locale,
                                    name: element.url,
                                  },
                                }"
                              >
                                {{ element.name }}
                              </router-link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>              
              </div>
              <div
                v-else
                class="d-flex flex-row align-items-center justify-content-center flex-wrap py-3 mb-3"
              >
                <div
                  v-for="item in pagesImages.data"
                  class="col-lg-3 mt-5"
                  :key="item.essay_id"
                >
                  <div
                    v-if="item.photo"
                    class="photos d-flex flex-row align-items-center justify-content-center flex-wrap pt-3"
                  >
                    <div
                      class="thumb"
                      @mouseover="visibleTrash = true"
                      @mouseleave="visibleTrash = false"
                    >
                      <img
                        class="thumb-pastas col-6"
                        :src="item.photo"
                        :alt="item.url + '-' + item.essay_id"
                        @click="goLink('ModelPage', { locale, name: item.url })"
                      />
                      <div
                        v-if="visibleTrash || isMobile()"
                        class="trash"
                        @click="removeFavoritePhotoId(item.id, showModalMessages)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash']" />
                      </div>
                      <div class="col-12 mt-2 text-center">
                        <router-link
                          :to="{
                            name: 'ModelPage',
                            params: {
                              locale,
                              name: item.url,
                            },
                          }"
                        >
                          {{ item.name }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="pagesImages.lastPage > 1 && pagesImages.data.length > 0"
                class="my-4 py-3"
              >
                <div class="row d-flex align-items-center justify-content-center">
                  <button
                    type="button"
                    class="read p-3 col-lg-3 col-8"
                    @click="
                      !myfavorites
                        ? getPhotosPaginateAlbumId(String(pagesImages.lastPage))
                        : getFavoritesModels(String(pagesImages.lastPage))
                    "
                  >
                    {{ translate.seeMore }}
                    <font-awesome-icon :icon="['fas', 'arrow-down']" size="md" />
                  </button>
                </div>
              </div>
              <div class="row d-flex flex-row align-items-center justify-content-center flex-wrap py-3 mb-3" v-if="listVideos.length">
                  <draggable ref="myVideosPosition"
                    tag="transition-group"
                    :handle="isMobile()?'.handle':''"                    
                    :animation="500"
                    :list="listVideos"                   
                    :sort="list.owner ? true : false"                    
                    :move="checkMove">
                    <template #item="{element}">
                      <div class="col-lg-4 col-md-6 col-12">
                        <BoxVideo
                          :video="element"
                          :key="element.id"
                        />
                        <div class="d-flex pb-3">
                          <div role="button" class="col-3 pb-3 handle" v-if="list.owner">
                            <font-awesome-icon :icon="['fas', 'up-down-left-right']" size="lg"/>
                          </div>
                          <div class="ps-3">
                            {{ element.modelname }} - {{ element.partname }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </draggable>
              </div>
            </div>
          </div>
        </div>
        <!-- Cometarios -->
        <div class="box-gray px-3">
          <div class="container">
            <div class="row d-flex align-items-center justify-content-center">
              <div class="box-w">
                <span class="title-comments" v-if="list.comments.length">{{
                  translate.commentAllBox
                }}</span>
                <div class="list-comentarios" v-if="list.comments.length">
                  <div
                    v-for="(comment, index) in list.comments"
                    :key="index"
                    class="card-comment"
                  >
                    <div>
                      <img
                        v-if="comment.ativo == 'true'"
                        :src="IconeBds"
                        alt="Assinante"
                        title="Assinante"
                      />
                      <span>
                        <strong>{{ comment.alias ? comment.alias : (locale == "pt-br" ? "Anônimo" : "Anonymous") }}</strong>
                      </span>
                      {{ translate.wroteOn }} {{ comment.date }}
                      <span class="a-answer text-answer" @click="toggle(comment)">
                        {{ translate.answer }}</span
                      >
                    </div>
                    <legend>{{ comment.comment }}</legend>
                    <hr />
                    <div
                      v-for="(commentAnswer, indexAnswer) in comment.answers"
                      :key="indexAnswer"
                      class="card-comment answer"
                    >
                      <div>
                        <img
                          v-if="commentAnswer.ativo == 'true'"
                          :src="IconeBds"
                          alt="Assinante"
                          title="Assinante"
                          width="12"
                          height="12"
                        />
                        <span>
                          <strong>{{ commentAnswer.alias ? commentAnswer.alias : (locale == "pt-br" ? "Anônimo" : "Anonymous") }}</strong>
                        </span>
                        {{ translate.wroteOn }} {{ commentAnswer.date }}
                      </div>
                      <legend>{{ commentAnswer.comment }}</legend>
                      <hr />
                    </div>
                    <div v-if="answered_comment_id === comment.id" class="box-w-2 answer">
                      <div class="questionario row">
                        <input
                          type="hidden"
                          class="form-control"
                          name="answered_comment_id"
                          v-model="answered_comment_id"
                        />
                        <span class="quest-title"> {{ translate.yoursComment }}</span>
                        <span class="quest-nickname" v-if="user.name">
                          {{ translate.yourNickname }} {{ user.nickname ?? user.name }} 
                          ( <a @click="showNicknameAnswer(user.nickname)" class="alter-nickname">{{ translate.alterNickName }}</a> )
                          <input v-if="nicknameCommentAnswerShow" class="form-control" required type="text" v-model="nicknameCommentAnswer">
                        </span>
                        <div class="row" v-else>
                          <div class="col-6">
                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control"
                                name="name"
                                :placeholder="translate.yourName"
                                v-model="nomeCommentAnswer"
                              />
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control"
                                name="email"
                                :placeholder="translate.yourEmail"
                                v-model="emailCommentAnswer"
                              />
                            </div>
                          </div>
                          <div class="col-lg-6 col-12 accept mt-3">
                            <input
                              type="checkbox"
                              name="acept"
                              id="acept"
                              v-model="newsletterCommentAnswer"
                            />
                            <label for="checkbox">{{ translate.formNewsCheck }}</label>
                          </div>
                        </div>
                        <div class="mb-3">
                          <textarea
                            class="form-control"
                            id="text-comment-bella"
                            :placeholder="translate.inputComment"
                            rows="5"
                            v-model="comentarioAnswer"
                          ></textarea>
                        </div>
                        <vue-recaptcha
                          ref="redAnswer"
                          v-if="showRecaptchaAnswer"
                          :sitekey="recaptchaSiteKey"
                          v-on:verify="recaptchaUpdatedAnswer"
                          hl="pt-br"
                        ></vue-recaptcha>
                        <a
                          class="button mt-2"
                          @click="saveCommentAnswer(showModalMessages)"
                        >
                          {{ translate.button }}
                          <i class="icon-arrow-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-w-2">
                <div class="questionario row">
                  <span class="quest-title"> {{ translate.yoursComment }}</span>
                  <span class="quest-nickname" v-if="user.name">
                    {{ translate.yourNickname }} {{ user.nickname ?? user.name }} 
                    ( <a @click="showNickname(user.nickname)" class="alter-nickname">{{ translate.alterNickName }}</a> )
                    <input v-if="nicknameCommentShow" class="form-control" required type="text" v-model="nicknameComment">
                  </span>
                  <div class="row" v-else>
                    <div class="col-6">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          name="cpf"
                          :placeholder="translate.yourName"
                          v-model="nomeComment"
                        />
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          name="cpf"
                          :placeholder="translate.yourEmail"
                          v-model="emailComment"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12 accept mt-3">
                      <input
                        type="checkbox"
                        name="acept"
                        id="acept"
                        v-model="newsletterComment"
                      />
                      <label for="checkbox">{{ translate.formNewsCheck }}</label>
                    </div>
                  </div>
                  <div class="mb-3">
                    <textarea
                      class="form-control"
                      id="text-comment-bella"
                      :placeholder="translate.inputComment"
                      rows="5"
                      v-model="comentario"
                    ></textarea>
                  </div>
                  <vue-recaptcha
                    ref="red"
                    v-if="showRecaptcha"
                    :sitekey="recaptchaSiteKey"
                    v-on:verify="recaptchaUpdated"
                    hl="pt-br"
                  ></vue-recaptcha>
                  <a
                    href="#"
                    class="button mt-2"
                    @click.prevent="saveComment(showModalMessages)"
                  >
                    {{ translate.button }}
                    <i class="icon-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="buttonOrder">
      <div class="text-center mt-3 loading-order" v-if="loadingOrder">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <a v-else 
        href="#"
        class="button button-order mt-2 col-12"
        @click.prevent="saveOrder(showModalMessages)"
        >
        {{ translate.buttonSaveOrder }}
        <i class="icon-floppy"></i>
      </a>
    </div>

    <ModalModelBellacloudZoom
      @showModalModelSlideShow="showModalModelSlideShow"
      :showSlide="showSlide"
      :imgSlide="imgSlide"
    />
    <ModalModelBellacloud
      @showModalModelBellacloud="showModalModelBellacloud"
      :showCloud="showCloud"
      :imageIdSelected="selectBellaCloudImg"
      :video="false"
    />
  </MainLayout>
</template>

<script lang="ts">
import { mapState, mapActions } from "pinia";
import { defineComponent } from "vue";
import { localeStore } from "stores/locale";
import tradutor from "tradutors/bellacloud";
import api from "../../api";
import { userStore } from "../../stores/user";
import router from "../../router";
import vueRecaptcha from "vue3-recaptcha2";
import { isMobile } from "../shared/utils/mobile";
import draggable from 'vuedraggable'

export default defineComponent({
  name: "ContactUsView",
  computed: {
    ...mapState(localeStore, ["locale"]),
    ...mapState(userStore, ["isLoggedIn", "user"]),
    translate: function () {
      if (this.locale === "pt-br") {
        return tradutor.portugues;
      } else {
        return tradutor.ingles;
      }
    },
  },
  components: {
    vueRecaptcha,
    draggable,
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.translate.title,
        page_url: window.location.origin + this.$route.fullPath,
        page_description:
          this.locale == "pt-br"
            ? `O Bella Cloud é um lugar onde você armazena as fotos e vídeos do Bella da Semana que mais gosta. Nele é possível criar álbuns privados, ou compartilhados com seus amigos e outros usuários.`
            : `Bella Cloud is a place where you store the photos and videos of the Bella Club you like best. It is possible to create private albums, or shared with your friends and other users.`,
        page_image: "/favicon.ico",
        page_keywords:
          "bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site",
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/bellacloud/album/view/"+this.list.id+"/"+this.list.url,
        page_url_en: "https://belladasemana.com.br/en/bellacloud/album/view/"+this.list.id+"/"+this.list.url,
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      },
    };
  },
  data() {
    return {
      visibleTrash: false,
      showDropMenu: false,
      myfavorites: false,
      list: {
        photos: [],
        name: "",
        comments: [],
        curtiu: 0,
        likes: 0,
        user: {
          id: null,
          name: "",
        },
        owner: false,
      },
      listVideos: [],
      pagesImages: {
        data: [],
        lastPage: 0,
      },
      loading: true,
      loadingPhotos: false,
      loadingOrder: false,      
      nomeComment: "",
      emailComment: "",
      newsletterComment: true,
      comentario: "",
      nicknameComment: "",      
      nicknameCommentShow: false,
      nomeCommentAnswer: "",
      emailCommentAnswer: "",
      newsletterCommentAnswer: true,
      comentarioAnswer: "",
      nicknameCommentAnswer: "",
      nicknameCommentAnswerShow: false,      
      answered_comment_id: "",
      showRecaptcha: true,
      showRecaptchaAnswer: true,
      recaptcha: null,
      recaptchaAnswer: null,
      recaptchaSiteKey: "6LcqxykUAAAAADAOWqu2zCV2_uaW1IMDzoiKfn5J",
      showSlide: false,
      imgSlide: "",
      showCloud: false,
      selectBellaCloudImg: 0,
      buttonOrder: false      
    };
  },
  created() {
    const lang = ["pt-br", "en"];
    if (lang.indexOf(this.$route.params.locale) === -1 || !this.$route.params.albumId) {
      window.location.replace("/");
    }
    if (this.$route.params.albumId) this.getAlbumId();
  },

  methods: {
    showModalModelBellacloud(value) {
      this.showCloud = value;
    },
    async getAlbumId() {
      this.loading = true;
      api
        .get(
          `v1/bellacloud/getAlbum/${this.$route.params.albumId}?locale=${
            this.locale ?? this.$route.params.locale
          }`, { headers:{'X-Custom-Data': this.$cookies.isKey('commentUser') ? this.$cookies.get('commentUser') : ''}}
        )
        .then(({ data }) => {
          if (data.id &&
              data.id == this.$route.params.albumId &&
              data.url == this.$route.params.nameAlbum
          ) {
            this.list = data;
            this.getPhotosPaginateAlbumId();
          } else {
            this.redirect('404');
          }
        })
        .catch(() => (this.redirect('404')))
        .finally(() => (this.loading = false));
    },
    async getPhotosPaginateAlbumId(page = "") {
      this.showDropMenu = false;
      if (page=="") {      
        this.buttonOrder = false;      
      }
      this.myfavorites = false;
      this.loadingPhotos = true;
      this.listVideos = [];
      api
        .get(
          `v1/bellacloud/getImagesMaskPaginationAlbumId/${
            this.$route.params.albumId
          }?locale=${this.locale ?? this.$route.params.locale}&page=${page}`
        )
        .then(({ data }) => {
          let arrayTemp = [];
          if (page) arrayTemp = this.pagesImages.data.concat(data.data);
          else arrayTemp = data.data;

          this.pagesImages.data = arrayTemp;
          let pageNext = data.next_page_url
            ? this.valueNextPage(data.next_page_url)
            : this.pagesImages.lastPage;
          this.pagesImages.lastPage =
            pageNext == this.pagesImages.lastPage ? 0 : pageNext;
        })
        .finally(() => (this.loadingPhotos = false));
    },
    async adicionarMyBellaCloud(photoId) {
      this.selectBellaCloudImg = photoId;
      this.showModalModelBellacloud(true);
    },
    async getFavoritesModels(page = "") {
      this.showDropMenu = false;
      this.buttonOrder = false;      
      this.myfavorites = true;
      this.loadingPhotos = true;
      this.listVideos = [];
      api
        .get(
          `v1/bellacloud/getMyFavoriteModelsPagination?locale=${
            this.locale ?? this.$route.params.locale
          }&page=${page}`
        )
        .then(({ data }) => {
          if (data) {
            let arrayTemp = [];
            if (page) arrayTemp = this.pagesImages.data.concat(data.data);
            else arrayTemp = data.data;

            this.pagesImages.data = arrayTemp;
            let pageNext = data.next_page_url
              ? this.valueNextPage(data.next_page_url)
              : this.pagesImages.lastPage;
            this.pagesImages.lastPage =
              pageNext == this.pagesImages.lastPage ? 0 : pageNext;
          }
        })
        .finally(() => (this.loadingPhotos = false));
    },
    async getVideosAlbumId() {
      this.showDropMenu = false;
      this.buttonOrder = false;      
      this.loadingPhotos = true;
      api
        .get(
          `v1/bellacloud/getAlbumVideos/${this.$route.params.albumId}?locale=${
            this.locale ?? this.$route.params.locale
          }`
        )
        .then(({ data }) => {
          this.listVideos = data;
          this.pagesImages.data = [];
          this.pagesImages.lastPage = 0;
        })
        .finally(() => (this.loadingPhotos = false));
    },
    valueNextPage(url) {
      // Expressão regular para extrair o valor do parâmetro "page"
      const regex = /page=(\d+)/;

      // Executar a expressão regular na URL
      const match = url.match(regex);

      // Verificar se houve correspondência e obter o valor do parâmetro "page"
      const page = match ? match[1] : null;

      return page;
    },
    goLink(name, params) {
      router.push({ name, params });
    },
    saveComment(message) {
      let form = {
        nome: this.nomeComment,
        email: this.emailComment,
        newsletter: this.newsletterComment,
        comentario: this.comentario,
        answered_comment_id: "",
        locale: this.locale,
      };

      if (this.nicknameCommentShow) {
        form["nickname"] = this.nicknameComment;
      } else {
        form["nickname"] = this.user.nickname;
      }

      form["g-recaptcha-response"] = this.recaptcha;

      if (!this.recaptcha)
        return message({
          message: {
            show: true,
            title: this.locale == "pt-br" ? "Erro" : "Error",
            textButton: this.locale == "pt-br" ? "Fechar" : "Close",
            textBoby:
              this.locale == "pt-br" ? "Preencha o Recaptcha!" : "Complete the Recaptcha",
          },
        });

      api
        .post(`v1/bellacloud/comment/${this.$route.params.albumId}`, form)
        .then(({ data }) => {
          if (this.nicknameCommentShow && this.nicknameComment != "") {
            api.get('v1/myaccount/getUser').then(({ data }) => {
              this.setUser(data);              
            })            
          }
          message({
            message: {
              show: true,
              title: this.locale == "pt-br" ? "Aviso" : "Notice",
              textButton: this.locale == "pt-br" ? "Fechar" : "Close",
              textBoby: data.message,
            },
          });
          if (data.userId) {
            this.$cookies.set('commentUser', btoa(data.userId), 1000 * 60 * 60 * 24 * 7)
          }
          this.nomeComment = "";
          this.emailComment = "";
          this.comentario = "";
          this.nicknameComment = "";
          this.nicknameCommentShow = false;
        })
        .catch((err) => {
            if (err.response.status === 400 && err.response.data.message)
              message({
                message: {
                  show: true,
                  title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                  textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                  textBoby: err.response.data.message
                }
              })
            else
              message({
                message: {
                  show: true,
                  title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                  textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                  textBoby:
                    this.locale == 'pt-br'
                      ? 'Falha ao enviar comentario!'
                      : 'Failed to send comment!'
                }
              })
          })

      this.recaptchaExpired();
    },
    saveCommentAnswer(message) {
      let form = {
        nome: this.nomeCommentAnswer,
        email: this.emailCommentAnswer,
        newsletter: this.newsletterCommentAnswer,
        comentario: this.comentarioAnswer,
        answered_comment_id: this.answered_comment_id,
        locale: this.locale,
      };

      if (this.nicknameCommentAnswerShow) {
        form["nickname"] = this.nicknameCommentAnswer;
      } else {
        form["nickname"] = this.user.nickname;
      }

      form["g-recaptcha-response"] = this.recaptchaAnswer;

      if (!this.recaptchaAnswer)
        return message({
          message: {
            show: true,
            title: this.locale == "pt-br" ? "Erro" : "Error",
            textButton: this.locale == "pt-br" ? "Fechar" : "Close",
            textBoby:
              this.locale == "pt-br" ? "Preencha o Recaptcha!" : "Complete the Recaptcha",
          },
        });

      api
        .post(`v1/bellacloud/comment/${this.$route.params.albumId}`, form)
        .then(({ data }) => {
          if (this.nicknameCommentAnswerShow && this.nicknameCommentAnswer != "") {
            api.get('v1/myaccount/getUser').then(({ data }) => {
              this.setUser(data);              
            })            
          }
          message({
            message: {
              show: true,
              title: this.locale == "pt-br" ? "Aviso" : "Notice",
              textButton: this.locale == "pt-br" ? "Fechar" : "Close",
              textBoby: data.message,
            },
          });
          if (data.userId) {
            this.$cookies.set('commentUser', btoa(data.userId), 1000 * 60 * 60 * 24 * 7)
          }
          this.nomeCommentAnswer = "";
          this.emailCommentAnswer = "";
          this.comentarioAnswer = "";
          this.answered_comment_id = "";
          this.nicknameCommentAnswer = "";
          this.nicknameCommentAnswerShow = false;
        })
        .catch((err) => {
            if (err.response.status === 400 && err.response.data.message)
              message({
                message: {
                  show: true,
                  title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                  textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                  textBoby: err.response.data.message
                }
              })
            else
              message({
                message: {
                  show: true,
                  title: this.locale == 'pt-br' ? 'Erro' : 'Error',
                  textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
                  textBoby:
                    this.locale == 'pt-br'
                      ? 'Falha ao enviar comentario!'
                      : 'Failed to send comment!'
                }
              })
          })
      this.recaptchaExpiredAnswer();
    },
    toggle: function (comment) {
      this.nomeCommentAnswer = "";
      this.emailCommentAnswer = "";
      this.newsletterCommentAnswer = true;
      this.comentarioAnswer = "";
      this.nicknameCommentAnswer = "";
      this.nicknameCommentAnswerShow = false;
      if (this.answered_comment_id == comment.id) {
        this.answered_comment_id = "";
      } else {
        this.answered_comment_id = comment.id;
      }
    },
    recaptchaExpired() {
      this.$refs.red.reset();
    },
    recaptchaExpiredAnswer() {
      this.$refs.redAnswer.reset();
    },
    async removeFavoritePhotoId(id, message) {
      api
        .delete(`v1/bellacloud/removeModelFromFavorite/${id}`)
        .then(() => {
          message({
            message: {
              show: true,
              title: "Aviso",
              textButton: "Fechar",
              textBoby:
                this.locale == "pt-br"
                  ? "Modelo removida com sucesso!"
                  : "Model removed successfully!",
            },
          });
          this.getFavoritesModels();
        })
        .catch(() => {
          message({
            message: {
              show: true,
              title: "Error",
              textButton: "Fechar",
              textBoby:
                this.locale == "pt-br"
                  ? "Falha ao remover modelo!"
                  : "Failed to remove model",
            },
          });
        });
    },
    async removePhotoId(albumId, photoId, message) {
      api
        .delete(`v1/bellacloud/removePhotoFromAlbum/${albumId}/${photoId}`)
        .then(() => {
          message({
            message: {
              show: true,
              title: "Aviso",
              textButton: "Fechar",
              textBoby:
                this.locale == "pt-br"
                  ? "Foto removida com sucesso!"
                  : "Photo removed successfully!",
            },
          });
          this.getPhotosPaginateAlbumId();
        })
        .catch(() => {
          message({
            message: {
              show: true,
              title: "Error",
              textButton: "Fechar",
              textBoby:
                this.locale == "pt-br"
                  ? "Falha ao remover foto!"
                  : "Failed to remove photo",
            },
          });
        });
    },
    recaptchaUpdated(recaptcha) {
      this.recaptcha = recaptcha;
    },
    recaptchaUpdatedAnswer(recaptcha) {
      this.recaptchaAnswer = recaptcha;
    },
    getLike() {
      if (this.isLoggedIn) {
        this.loadingMyAlbum = true;

        api
          .post("v1/bellacloud/likeOrUnlikeAlbumId", {
            albumId: this.list.id,
            actionLike: Number(!this.list.curtiu),
          })
          .then(() => {
            this.resetImgs();
            this.getAlbumId();
          })
          .finally(() => (this.loading = false));
      }
    },
    resetImgs() {
      this.pagesImages = {
        data: [],
        lastPage: 0,
      };
    },
    goBack() {
      router.go(-1);
    },
    async showModalModelSlideShow(value, item = null) {
      if ((!item?.photo.includes("belladasemana") && value) || !value) {
        this.buttonOrder = false
        this.showSlide = value;
        this.imgSlide = "";
        if (value) {
          this.imgSlide = await this.getPhostosMask(item.essay_photos_id);

          if (this.imgSlide) {
            let body = document.getElementsByTagName("body");
            body[0].style.overflowY = "hidden";
          }
        } else {
          let body = document.getElementsByTagName("body");
          body[0].style.overflowY = "auto";
        }
      }
    },
    async getPhostosMask(id) {
      return api
        .get(
          "v1/bellacloud/getModelPhotoMaskZoom/" +
            id +
            `?locale=${this.locale ?? this.$route.params.locale}`
        )
        .then(({ data }) => data);
    },
    redirect(name) {
      router.push({
        name,
        params: {
          locale: this.locale
        }
      })
    },   
    showNickname(nickname) {
      this.nicknameComment = nickname
      this.nicknameCommentShow = true      
    },
    showNicknameAnswer(nickname) {
      this.nicknameCommentAnswer = nickname
      this.nicknameCommentAnswerShow = true      
    },
    ...mapActions(userStore, ['setUser']),    
    checkMove() {
      this.buttonOrder = true
    },
    saveOrder(message) {
      this.loadingOrder = true
      var newOrder = []
      if (this.listVideos.length) {
        this.$refs.myVideosPosition.list.forEach(element => {
          newOrder.push(element.essay_part_id)
        });
        var routeOrder = 'updateVideosOrderApi'
      } else {
        this.$refs.myPhotosPosition.list.forEach(element => {
          newOrder.push(element.essay_photos_id)
        });
        var routeOrder = 'updatePhotosOrderApi'
      }
      let form = {
        orderList: newOrder,
        albumId: this.$route.params.albumId,
        locale: this.locale
      };      
      api
        .post(`v1/bellacloud/${this.$route.params.albumId}/${routeOrder}`, form)
        .then(({ data }) => {
          message({
            message: {
              show: true,
              title: '',
              textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
              textBoby: data.message ?? data.error
            }
          })
          if (data.message) {
            this.buttonOrder = false            
          }
          this.loadingOrder = false
        })
        .catch((data) => {
          message({
            message: {
              show: true,
              title: '',
              textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
              textBoby: data
            }
          })
          this.loadingOrder = false          
        })
    }
  },
});
</script>

<style lang="css" scoped>
.trash {
  position: absolute;
  bottom: 0;
  right: 10px;
  font-size: 30px;
  color: #b20000;
}

.routes span {
  color: #999999;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
}

.container {
  min-height: 65px;
}

.name-pasta {
  font-family: "Roboto-Medium";
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
}

.title {
  font-family: "Bebas-Neue-Light";
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

.read {
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
}

.read svg {
  color: #b20;
  margin-left: 8px;
}

.name-pastas {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}

.subtitle {
  color: #5b5858;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.photos {
  width: 100%;
  min-height: 200px;
  cursor: pointer;
}

.thumb {
  height: 363px;
  width: 242px;
  border: 1px solid #979797;
  background-color: #d8d8d8;
  border-radius: 5px;
  margin: 5px;
  box-sizing: border-box;
  padding: 0;
}

.thumb-pastas {
  width: 100%;
  margin: 0;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}

hr {
  height: 2px;
  opacity: 0.1;
  transform: scaleY(-1);
  background-color: #000000;
}

.link-login {
  font-size: 18px;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

label {
  height: 23px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 23px;
}

input[type="checkbox"] {
  position: relative;
  cursor: pointer;
  margin-inline: 15px;
  width: 20px;
  height: 20px;
}

input[type="checkbox"]:before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  top: -3px;
  left: -3px;
  background-color: #000;
}

input[type="checkbox"]:checked:before {
  content: "";
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  top: -3px;
  left: -3px;
  background-color: #000;
}

input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  width: 9px;
  height: 15px;
  border: solid red;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 2px;
  left: 6px;
}

.form-group input {
  padding: 15px 20px;
  border-radius: 30px;
  background-color: #fff;
  font-size: small;
}

.form-control:focus {
  color: #000;
  background-color: #f8f8f8;
}

.img-banner-rodape {
  height: 124px;
  width: 1012px;
}

.button {
  height: 50px;
  width: 170px;
  margin-bottom: 56px;
  cursor: pointer;
  border-radius: 30px;
  margin-left: 10px;
}

.button-order {
  position: fixed;
  z-index: 9999;
  left: 50%;
  transform: translate(-50%);
  top: 50%;
  width: 230px;  
  border: 1px solid #FFFFFF
}

.loading-order {
  position: fixed;
  z-index: 9999;
  left: 50%;
  transform: translate(-50%);
  top: 50%;
}

.quest-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
  margin-bottom: 8px;
}

.quest-nickname {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 16px;
}

.form-control {
  margin-top: 10px;
  background-color: #fff;
  color: #868686;
  font-size: 14px;
  font-weight: 600;
  font-family: "Exo-2";
}

.card-comment > div {
  font-family: "Roboto-Regular";
  font-size: 13px;
}

.card-comment > legend {
  font-family: "Roboto-Regular";
  font-size: 16px;
  line-height: 19px;
}

.card-comment > div > span {
  font-family: "Roboto-Bold";
  font-size: 13px;
  color: #000;
}

.card-comment > hr {
  margin-bottom: 10px !important;
  background-color: #cccccc;
}

.list-comentarios {
  margin-top: 5px;
}

.list-comentarios img {
  width: 12px;
  margin-right: 5px;
  object-fit: cover;
}

.box-title {
  max-width: 808px;
  padding-inline: 0;
}

.box-details {
  width: 808px;
  padding-inline: 0;
  margin-top: 56px;
}

.box-gray {
  background-color: #f8f8f8;
  width: 100%;
}

.box-details span {
  font-size: 16px;
  line-height: 19px;
  color: #666;
}

.box-w {
  margin-top: 56px;
  width: 808px;
  padding-inline: 0;
}

.box-w-2 {
  margin-top: 50px;
  width: 808px;
  padding-inline: 0;
}

.title-comments {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  line-height: 28px;
  padding-inline: 0;
}

.card-text {
  font-family: "Roboto-Regular";
  font-size: 13px;
  line-height: 15px;
  color: #999;
}

.likes {
  cursor: pointer;
}

.dropdown-toggle {
  &:after {
    font-family: "Roboto-Regular";
    font-size: 18px;
    content: "\e809";
    margin: 0;
    border: none;
    vertical-align: top;
  }
}

.dropdown-menu {
  margin: 0.7rem;
  background-color: #fff;
  color: #999;
}

.dropdown-item {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  padding: 0.75rem;
}

.answer {
  padding-left: 50px !important;
}

.text-answer {
  color: #b20000 !important;
  font-family: "Roboto-Regular" !important;
  font-size: 14px;
  cursor: pointer;
  padding-left: 10px;
}

.alter-nickname{
  color: #b20000;
  cursor: pointer;
  font-size: 13px;  
}

:deep(.iframe-video) {
    min-height: 230px !important;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .subtitle {
    color: #b20000;
  }

  :deep(.iframe-video) {
    min-height: 185px !important;
    width: 92%;
  }

  :deep(.fullscreen-button) {
    right: 10% !important;
  }  
  .button-order {
    width: 210px;
  }

  .thumb {
    width: 100% !important;
    height: 463px;
  }
}
</style>
